export function slugifyId(id: string) {
  return `${id}-slugified`;
}
